import { render, staticRenderFns } from "./teacherLive.vue?vue&type=template&id=ffb2f39e&"
import script from "./teacherLive.vue?vue&type=script&lang=js&"
export * from "./teacherLive.vue?vue&type=script&lang=js&"
import style0 from "./teacherLive.vue?vue&type=style&index=0&id=ffb2f39e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports